export default __webpack_public_path__ + "static/media/746385107023036536.6eec86c6.png";